import React, { useContext } from 'react';
import classNames from 'classnames';
// @ts-ignore
import standardLogo from '../../../assets/logos/john-lewis-partners.svg';
// @ts-ignore
import teaseSvgLogo from '../../../assets/logos/john-lewis-logo-linear.svg';
// @ts-ignore
import logoPride from '../../../assets/logos/JL_Pride_Logo_2025.svg';
// @ts-ignore
import logoXmas from '../../../assets/logos/john-lewis-christmas-2025-dark.svg';
import styles from './logo.scss';
import { EnvVarsFeaturesContext } from '../../scaffold/EnvVarsFeaturesContext';
import { isMonetateGroup } from '../../utils/monetate/isMonetateGroup';

export const logoAssetsPath =
  (assetsPath: string) =>
  (asset: string): string =>
    assetsPath ? `${assetsPath}/images/${asset.split('/').pop()}` : asset;

const getLogoSrc = (
  assetsPath: string,
  teaseLogoActive: boolean,
  prideLogoActive: boolean,
  xmasLogoActive: boolean
): string => {
  const logoWithAssetsPath = logoAssetsPath(assetsPath);
  if (teaseLogoActive) return logoWithAssetsPath(teaseSvgLogo);
  if (prideLogoActive) return logoWithAssetsPath(logoPride);
  if (xmasLogoActive) return logoWithAssetsPath(logoXmas);
  return logoWithAssetsPath(standardLogo);
};

interface LogoProps {
  splashScreen?: boolean;
}

export const Logo = ({ splashScreen }: LogoProps) => {
  const { envVars, features } = useContext(EnvVarsFeaturesContext);
  const teaseLogoActive = isMonetateGroup(features as any, 'enable tease logo');
  const prideLogoActive = isMonetateGroup(features as any, 'enable pride logo');
  const xmasLogoActive = isMonetateGroup(
    features as any,
    'enable christmas logo'
  );
  const logoSrc = getLogoSrc(
    envVars?.assetsPath || '',
    teaseLogoActive,
    prideLogoActive,
    xmasLogoActive
  );

  return (
    <div
      className={classNames(styles.container, {
        [styles.container__expandedSearch]: splashScreen,
        [styles.container__tease]: teaseLogoActive,
      })}
      data-testid="logo-container"
    >
      <a className={styles.link} href="/">
        <img
          src={logoSrc}
          alt="John Lewis & Partners Home"
          className={styles.logo}
        />
      </a>
    </div>
  );
};
